// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2QIM6","footer":"ModalError_footer__3GBxS"};